
const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer 
      className="border-t border-gray-800 relative overflow-hidden"
      style={{
        backgroundColor: '#0D0F14',
        backgroundImage: `linear-gradient(rgba(10, 10, 10, 0.6), rgba(10, 10, 10, 0.6)), url('https://public.readdy.ai/ai/img_res/a39b8033c1686bca371f56123744dfc2.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/20 to-blue-900/10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-start space-x-4 mb-4">
              <img 
                src="https://static.readdy.ai/image/d1a1e642d5f2b502ecdb8131dab4af6d/93a05c58da5d0229f0b20420462c0917.png" 
                alt="Inspiring Life" 
                className="h-20 flex-shrink-0"
              />
              <div className="flex flex-col justify-between h-20">
                <p className="text-gray-400 text-sm leading-relaxed max-w-[750px]">
                  Empowering growth through knowledge, technology, and decentralization.<br/>
                  Your trusted partner in business consulting, digital innovation,<br/>
                  and infrastructure solutions for sustainable success.
                </p>
                <div className="flex space-x-4">
                  <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                    <i className="ri-twitter-fill text-xl"></i>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">
                    <i className="ri-github-fill text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <p className="text-gray-400">
                <i className="ri-mail-line mr-2"></i>
                contact@inspiringlife.llc
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Inspiring Life LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
